import { createOptionBindings } from '@ff-os/pdp-shared-redux/slices/sceneSlice';
import { PhotoPrintsSceneOptions } from '@ff-scene-plugins/photo-prints-shared/PhotoPrintsSceneOptions';
import { PhotoPrintsPdpState } from '../store';

const optionsBindings = createOptionBindings<PhotoPrintsSceneOptions, PhotoPrintsPdpState>();
const adapterSelectors = optionsBindings.createEntityOptionSelectors(s => s.variants);

export const selectAllVariants = adapterSelectors.selectAll;

export const selectVariantById = adapterSelectors.selectById;

export const selectVariantEntities = adapterSelectors.selectEntities;